import React from "react";
import styles from "./PageContent.module.scss";
import MaxWidthContainer from "@src/components/containers/MaxWidthContainer";

interface PageContentProps {
  children: React.ReactNode;
}

export default function PageContent({
  children,
}: PageContentProps): React.JSX.Element {
  return (
    <MaxWidthContainer>
      <main className={styles.root}>{children}</main>
    </MaxWidthContainer>
  );
}
